const AUTH_DARK_THEME_VARS = {
  "--color-primary-override": "#1252D2",
  "--color-secondary-override": "#386EDA",
  "--color-gray": "#686565",
  "--color-bg-main": "#101622",
  "--color-bg-container": "#1A2231",
  "--color-textinput-background": "#262E40",
  "--color-text-main": "#ffffff",
  "--color-text-secondary": "#b0b7d2",
  "--color-text-error": "#ff5555",
  "--color-text-blue": "#386EDA",
  "--color-border-input": "#2f3c75",
};

export const applyAuthDarkTheme = () => {
  if (typeof document === "undefined") {
    return;
  }

  const root = document.documentElement;

  Object.entries(AUTH_DARK_THEME_VARS).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
};

export const clearAuthDarkTheme = () => {
  if (typeof document === "undefined") {
    return;
  }

  const root = document.documentElement;

  Object.keys(AUTH_DARK_THEME_VARS).forEach((key) => {
    root.style.removeProperty(key);
  });
};
